import { render } from "./MainSlide.vue?vue&type=template&id=467f4663&scoped=true"
import script from "./MainSlide.vue?vue&type=script&lang=js"
export * from "./MainSlide.vue?vue&type=script&lang=js"

import "./MainSlide.vue?vue&type=style&index=0&id=467f4663&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467f4663"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QFab from 'quasar/src/components/fab/QFab.js';
import QFabAction from 'quasar/src/components/fab/QFabAction.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QBtn,QSpace,QPageContainer,QPage,QPageSticky,QFab,QFabAction});
